/**
 * Utility methods, mostly around Yup schema validation
 */
const yup = require('yup');

const {
  normalizeString
} = require('../../utils');

const uuidv4 = require('uuid/v4');

function optionalString() {
  return yup.string().trim();
}

function requiredString(message = 'required') {
  return optionalString().required(message);
}

function optionalNumber() {
  return yup.number();
}

function requiredNumber() {
  return optionalNumber().required();
}

function optionalInt() {
  return optionalNumber().integer();
}

function requiredInt() {
  return optionalInt().required();
}

function requiredDate() {
  return yup.date().required();
}

function optionalDate() {
  return yup.date();
}

function requiredObject() {
  return yup.object().required();
}

function optionalObject() {
  return yup.object().default(null).nullable();
}

function arrayOf(itemSchema) {
  return yup.array().of(itemSchema).ensure();
}

function requiredArrayOf(itemSchema, message = 'required') {
  return yup.array().of(itemSchema).ensure().required(message);
}

function optionalBool() {
  return yup.boolean();
}

function requiredBool() {
  return yup.boolean().required();
}

function lazy(func) {
  return yup.lazy(func);
}
/**
 * This schema should be used for ID fields if needed on subobjects, as it will generate the field if it is not
 * already present
 */


function generatedId() {
  return requiredString().default(uuidv4());
}
/**
 * Validates the object against the given Yup schema with standard options.
 */


async function validateObject(schema, object) {
  return schema.validate(object, {
    abortEarly: false,
    stripUnknown: true
  });
}
/**
 * Normalize Field is used to add a field to an object that is just the normalized version of another field (e.g.
 * name and _nameNormalized). This is useful because when searching with Firestore, you'll almost always want to
 * search against a normalized string.
 * @param fieldPath The field path of the field you want normalized
 * @return {*} A yup schema that will generate the appropriate normalized value.
 */


function normalizeField(fieldPath) {
  return yup.string().when(fieldPath, (fieldValue, schema) => {
    // using default ensures the value will be added if it is missing (the normal case), and
    // transform ensures it will be properly overwritten if it is already there.
    const normalizedValue = normalizeString(fieldValue);
    return schema.default(normalizedValue).transform(valueToIgnore => normalizedValue);
  });
}

function requiredEmail(message = 'required') {
  return yup.string().email().required(message);
}

module.exports = {
  requiredString,
  optionalString,
  requiredNumber,
  optionalNumber,
  requiredInt,
  optionalInt,
  requiredDate,
  optionalDate,
  requiredObject,
  optionalObject,
  arrayOf,
  optionalBool,
  requiredBool,
  lazy,
  generatedId,
  normalizeField,
  validateObject,
  requiredArrayOf,
  requiredEmail
};